import { render, staticRenderFns } from "./TodayJobListview.vue?vue&type=template&id=38768598&"
import script from "./TodayJobListview.vue?vue&type=script&lang=js&"
export * from "./TodayJobListview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports